export enum VIEW_MODE {
  DATASETS = 'datasets',
  SETTINGS = 'settings',
  BUILT_INS = 'built_ins',
}
